/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import e from "./List.mjs";
import { classNames as a } from "@progress/kendo-react-common";
const i = (t) => /* @__PURE__ */ l.createElement(
  e,
  {
    ...t,
    wrapperCssClass: "k-table-body k-table-scroller",
    listClassName: a("k-table k-table-list", {
      "k-virtual-table": t.virtual !== void 0
    }),
    listStyle: { ...t.listStyle }
  }
);
export {
  i as MultiColumnList
};
